import { useCallback, useReducer, useEffect, useState } from "react"
import {
  View,
  ScrollView,
  Text,
  StyleSheet,
  ActivityIndicator,
  TouchableOpacity,
  Modal,
  TouchableWithoutFeedback,
} from "react-native"
import Header from "../../components/Header"
import Colors from "../../constants/Colors"
import Btn from "../../components/Btn"
import { useSelector } from "react-redux"
import axios from "axios"
import { logOut } from "../../components/Functions"
import Config from "../../constants/Config"
import Picker from "../../components/Picker"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"
import Input from "../../components/Input"

const INPUT_CHANGE = "INPUT_CHANGE"
const ALERT_SHOW = "ALERT_SHOW"
const SET_LOADING = "SET_LOADING"
const SET_ACCESS = "SET_ACCESS"
const SET_COURSES = "SET_COURSES"
const CHANGE_ACCESS = "CHANGE_ACCESS"

const TOGGLE_ERRORS_DIALOG = "TOGGLE_ERRORS_DIALOG"
const SET_ERRORS = "SET_ERRORS"

const formReducer = (state, action) => {
  switch (action.type) {
    case INPUT_CHANGE:
      return {
        ...state,
        values: {
          ...state.values,
          [action.id]: action.value,
        },
        validities: {
          ...state.validities,
          [action.id]: action.validity,
        },
      }
    case ALERT_SHOW:
      return {
        ...state,
        values: {
          ...state.values,
          showAlert: action.show,
          alertMessage: action.msg,
        },
      }
    case SET_LOADING:
      return {
        ...state,
        values: {
          ...state.values,
          loading: action.loading,
        },
      }
    case SET_ACCESS:
      return {
        ...state,
        values: {
          ...state.values,
          access: action.data,
        },
      }

    case SET_ERRORS:
      return {
        ...state,
        values: {
          ...state.values,
          errors: action.data,
        },
      }

    case TOGGLE_ERRORS_DIALOG:
      return {
        ...state,
        values: {
          ...state.values,
          showErrorsDialog: !state.values.showErrorsDialog,
        },
      }

    case SET_COURSES:
      let changedData = action.data
      changedData = changedData.map(({ title: item, ...rest }) => ({
        item,
        ...rest,
      }))
      return {
        ...state,
        values: {
          ...state.values,
          courses: changedData,
        },
      }
    case CHANGE_ACCESS:
      let newAccess = state.values.access
      for (let i = 0; i < newAccess.length; i++) {
        if (newAccess[i].id == action.id) {
          newAccess[i].has_access = action.active
        }
      }

      return {
        ...state,
        values: {
          ...state.values,
          access: newAccess,
        },
      }

    default:
      return state
  }
}

const ErrorItem = ({ item, apply_license, formState, dispatchFormState }) => {
  const [license, setLicense] = useState("")

  const licenseChangeHandler = useCallback(
    // You don't need any changes
    (id, value, validity) => setLicense(value),
    [dispatchFormState]
  )

  return (
    <View
      style={{
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        borderWidth: 1,
        borderColor: Colors.secondText,
        borderRadius: 15,
        padding: 15,
        paddingBottom: 0,
      }}
    >
      <View
        style={{
          width: "100%",
          gap: 10,
          flexDirection: "row-reverse",
          justifyContent: "center",
          alignItems: "center",
          height: 50,
        }}
      >
        <View
          style={{
            flex: 6,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: Colors.cardBg,
            padding: 15,
            borderRadius: 10,
            height: "100%",
          }}
        >
          <Text
            style={{
              fontFamily: "IranSans-Medium",
              fontWeight: 700,
              fontSize: 14,
              color: Colors.secondary,
            }}
          >
            {item.customer?.first_name + " " + item.customer?.last_name}
          </Text>
        </View>

        <TouchableOpacity
          onPress={() => {
            apply_license(item.customer?.id, item.course?.id, license)
          }}
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: Colors.primary,
            padding: 15,
            borderRadius: 10,
            height: "100%",
          }}
        >
          <MaterialCommunityIcons name="check-all" size={23} color="#FFFFFF" />
        </TouchableOpacity>
      </View>

      <Input
        label="کد لایسنس دوره"
        value={license}
        onChange={licenseChangeHandler}
        wrapperStyle={{ marginTop: 25 }}
        validity
      />
    </View>
  )
}

const SetCourseAccessScreen = (props) => {
  const token = useSelector((store) => store.user.token)
  const [formState, dispatchFormState] = useReducer(formReducer, {
    values: {
      loading: false,
      access: [],
      courses: [],
      selectedCourse: null,

      errors: [],
      showErrorsDialog: false,
    },
    validities: {},
  })

  const inputChangeHandler = useCallback(
    // You don't need any changes
    (id, value, validity) => {
      dispatchFormState({ type: INPUT_CHANGE, id, value, validity })
    },
    [dispatchFormState]
  )

  const get_course_access = async () => {
    const url =
      Config.aioUrl + "/lms/course/accessList?course_id=" + formState.values.selectedCourse.id
    let reqHedear = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    }

    dispatchFormState({ type: SET_LOADING, loading: true })
    axios({
      method: "get",
      url: url,
      headers: reqHedear,
    })
      .then(function (response) {
        if (response.data.code == 401) {
          alert("نیاز است مجددا به سیستم ورود کنید.")
          logOut()
        }
        dispatchFormState({ type: SET_LOADING, loading: false })
        dispatchFormState({ type: SET_ACCESS, data: response.data.data })
      })
      .catch(function (error) {
        dispatchFormState({ type: SET_LOADING, loading: false })
        dispatchFormState({ type: ALERT_SHOW, show: true, msg: error.response.data.message })
      })
  }

  const get_courses = async () => {
    const url = Config.aioUrl + "/lms/course/list"

    let reqHedear = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    }

    dispatchFormState({ type: SET_LOADING, loading: true })
    axios({
      method: "get",
      url: url,
      headers: reqHedear,
    })
      .then(function (response) {
        if (response.data.code == 401) {
          alert("نیاز است مجددا به سیستم ورود کنید.")
          logOut()
        }
        dispatchFormState({ type: SET_LOADING, loading: false })
        dispatchFormState({ type: SET_COURSES, data: response.data.data })
      })
      .catch(function (error) {
        dispatchFormState({ type: SET_LOADING, loading: false })
        dispatchFormState({ type: ALERT_SHOW, show: true, msg: error.response.data.message })
      })
  }

  const edit_access = async () => {
    const url = Config.aioUrl + "/lms/course/accessEdit"
    let reqHedear = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    }

    let reqData = JSON.stringify({
      course_id: formState.values.selectedCourse.id,
      access: formState.values.access,
    })
    dispatchFormState({ type: SET_LOADING, loading: true })
    axios({
      method: "post",
      url: url,
      data: reqData,
      headers: reqHedear,
    })
      .then(function (response) {
        if (response.data.code == 401) {
          alert("نیاز است مجددا به سیستم ورود کنید.")
          logOut()
        }

        if (response?.data?.errors && response?.data?.errors?.length > 0) {
          dispatchFormState({ type: TOGGLE_ERRORS_DIALOG })
          console.log(response)
          dispatchFormState({ type: SET_ERRORS, data: response.data.errors })
        }

        alert(response.data.msg)
        dispatchFormState({ type: SET_LOADING, loading: false })
      })
      .catch(function (error) {
        dispatchFormState({ type: SET_LOADING, loading: false })
        dispatchFormState({ type: ALERT_SHOW, show: true, msg: error.response.data.message })
      })
  }

  useEffect(() => {
    if (formState.values.selectedCourse) {
      get_course_access()
    }
  }, [formState.values.selectedCourse])

  useEffect(() => {
    const focused = props.navigation.addListener("focus", () => {
      get_courses()
    })

    return focused
  }, [props.navigation])

  const change_access_status = (id, active) => {
    dispatchFormState({ type: CHANGE_ACCESS, id: id, active: active })
  }

  const apply_license = (user_id, course_id, license) => {
    const url = Config.aioUrl + "/lms/course/single-access-edit"

    let reqHedear = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    }

    let reqData = {
      course_id: course_id,
      customer_id: user_id,
      spot_license: license,
    }

    dispatchFormState({ type: SET_LOADING, loading: true })

    axios({
      method: "post",
      url: url,
      data: reqData,
      headers: reqHedear,
    })
      .then(function (response) {
        if (response.data.code == 401) {
          alert("نیاز است مجددا به سیستم ورود کنید.")
          logOut()
        }

        alert(response.data.msg)
        dispatchFormState({ type: SET_LOADING, loading: false })

        if (response.data.code == 200) {
          let errors = [...formState.values.errors]

          errors = errors.filter((error) => error?.customer?.id != user_id)

          dispatchFormState({ type: SET_ERRORS, data: errors })

          if (errors.length == 0) {
            dispatchFormState({ type: TOGGLE_ERRORS_DIALOG })
          }
        }
      })
      .catch(function (error) {
        dispatchFormState({ type: SET_LOADING, loading: false })
        dispatchFormState({ type: ALERT_SHOW, show: true, msg: error.response.data.message })
      })
  }

  console.log(formState.values?.errors)

  return (
    <View
      style={{
        paddingHorizontal: 25,
        height: "100%",
        overflow: "hidden",
        backgroundColor: Colors.bg,
      }}
    >
      <Header title="دسترسی دوره ها" noBack />

      <ScrollView showsVerticalScrollIndicator={false} style={{ paddingBottom: 50 }}>
        <View style={{ flexDirection: "row-reverse" }}>
          <View
            style={{
              flex: 1,
              shadowColor: "#000",
              shadowOffset: { width: 0, height: 0 },
              shadowOpacity: 0.5,
              shadowRadius: 2,
              marginVertical: 3,
              marginHorizontal: 5,
              borderRadius: 7,
              paddingHorizontal: 10,
            }}
          >
            <View style={Styles.cardHeader}>
              <Text style={{ fontFamily: "IranSans-Bold", fontSize: 16 }}>انتخاب دوره</Text>
            </View>
            {formState.values.courses.length != 0 && (
              <Picker
                label="دوره"
                id="selectedCourse"
                onChange={inputChangeHandler}
                options={formState.values.courses}
              />
            )}
            {formState.values.selectedCourse && (
              <Btn
                title="ثبت تغییرات"
                onPress={() => {
                  edit_access()
                }}
                loading={formState.values.loading}
                wrapperStyle={{ marginBottom: 30 }}
              />
            )}
          </View>
          <View
            style={{
              flex: 3,
              shadowColor: "#000",
              shadowOffset: { width: 0, height: 0 },
              shadowOpacity: 0.5,
              shadowRadius: 2,
              marginVertical: 3,
              marginHorizontal: 5,
              borderRadius: 7,
              paddingHorizontal: 10,
            }}
          >
            <View style={Styles.cardHeader}>
              <Text style={{ fontFamily: "IranSans-Bold", fontSize: 16 }}>دسترسی های دوره</Text>
            </View>
            <View style={{ flex: 1, flexDirection: "row-reverse" }}>
              <View style={{ flex: 1, paddingHorizontal: 25, paddingBottom: 20 }}>
                <Text
                  style={{ fontFamily: "IranSans-Medium", marginBottom: 20, textAlign: "center" }}
                >
                  دارای دسترسی
                </Text>
                {formState.values.access
                  .filter((item) => {
                    if (item.has_access) return true
                  })
                  .map((item, index) => (
                    <TouchableOpacity
                      key={index}
                      onPress={() => {
                        change_access_status(item.id, false)
                      }}
                    >
                      <Text
                        style={{ fontFamily: "IranSans-Light", marginBottom: 10, fontSize: 12 }}
                      >
                        {item.first_name + " " + item.last_name + " (" + item.mobile + ")"}
                      </Text>
                    </TouchableOpacity>
                  ))}
              </View>
              <View style={{ flex: 1, paddingHorizontal: 25 }}>
                <Text
                  style={{ fontFamily: "IranSans-Medium", marginBottom: 20, textAlign: "center" }}
                >
                  بدون دسترسی
                </Text>
                {formState.values.access
                  .filter((item) => {
                    if (!item.has_access) return true
                  })
                  .map((item, index) => (
                    <TouchableOpacity
                      key={index}
                      onPress={() => {
                        change_access_status(item.id, true)
                      }}
                    >
                      <Text
                        style={{ fontFamily: "IranSans-Light", marginBottom: 10, fontSize: 12 }}
                      >
                        {item.first_name + " " + item.last_name + " (" + item.mobile + ")"}
                      </Text>
                    </TouchableOpacity>
                  ))}
              </View>
            </View>
          </View>
        </View>
      </ScrollView>

      <Modal animationType="fade" transparent={true} visible={formState.values.showErrorsDialog}>
        <TouchableOpacity
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            justifyContent: "center",
            alignItems: "center",
          }}
          activeOpacity={1}
          onPressOut={() => {
            dispatchFormState({ type: TOGGLE_ERRORS_DIALOG })
          }}
        >
          <TouchableWithoutFeedback>
            <View
              style={{
                width: 500,
                maxWidth: "95%",
                backgroundColor: Colors.bg,
                borderRadius: 15,
                paddingHorizontal: 25,
                paddingVertical: 35,
              }}
            >
              <ScrollView style={{ maxHeight: 500 }} showsVerticalScrollIndicator={false}>
                <View
                  style={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 20,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: "IranSans-Medium",
                      fontWeight: 700,
                      fontSize: 14,
                      color: Colors.secondary,
                      textAlign: "center",
                      lineHeight: 32,
                      marginBottom: 20,
                    }}
                  >
                    در اعمال دسترسی برای افراد زیر مشکلی پیش آمده است، میتوانید با برداشتن دستی
                    لایسنس از SpotPlayer دوره را برایشان فعال کنید
                  </Text>

                  {formState.values?.errors?.map?.((item, index) => (
                    <ErrorItem
                      item={item}
                      apply_license={apply_license}
                      formState={formState}
                      dispatchFormState={dispatchFormState}
                    />
                  ))}
                </View>
              </ScrollView>
            </View>
          </TouchableWithoutFeedback>
        </TouchableOpacity>
      </Modal>
    </View>
  )
}

const Styles = StyleSheet.create({
  cardHeader: {
    width: "100%",
    borderBottomColor: "#e6e6e6",
    borderBottomWidth: 0.5,
    alignItems: "center",
    paddingVertical: 10,
    marginVertical: 10,
  },
})

export const screenOptions = {
  headerShown: false,
  drawerPosition: "right",
}

export default SetCourseAccessScreen
